module.exports = __webpack_public_path__ + "static/media/info_svg.6b86cf24.svg";